// import React, { useEffect } from "react";

// const ComponentC = () => {
//   useEffect(() => {
//     const canvas = document.getElementById("aurora");
//     const ctx = canvas.getContext("2d");

//     let width, height;
//     const colors = [
//       "rgba(0, 255, 150, 0.2)", // green
//       "rgba(0, 200, 255, 0.2)", // cyan
//       "rgba(200, 0, 255, 0.2)", // purple
//       "rgba(255, 0, 150, 0.2)"  // pink
//     ];

//     const resize = () => {
//       width = window.innerWidth;
//       height = window.innerHeight;
//       canvas.width = width;
//       canvas.height = height;
//     };
//     resize();
//     window.addEventListener("resize", resize);

//     const gradientBands = [];
//     for (let i = 0; i < 5; i++) {
//       gradientBands.push({
//         x: Math.random() * width,
//         y: Math.random() * height,
//         radius: Math.random() * 500 + 300,
//         dx: (Math.random() - 0.5) * 0.2,
//         dy: (Math.random() - 0.5) * 0.2,
//         color: colors[Math.floor(Math.random() * colors.length)],
//       });
//     }

//     const animate = () => {
//       ctx.clearRect(0, 0, width, height);

//       gradientBands.forEach((g) => {
//         g.x += g.dx;
//         g.y += g.dy;

//         if (g.x < -g.radius || g.x > width + g.radius) g.dx *= -1;
//         if (g.y < -g.radius || g.y > height + g.radius) g.dy *= -1;

//         const gradient = ctx.createRadialGradient(g.x, g.y, 0, g.x, g.y, g.radius);
//         gradient.addColorStop(0, g.color);
//         gradient.addColorStop(1, "transparent");

//         ctx.fillStyle = gradient;
//         ctx.fillRect(0, 0, width, height);
//       });

//       requestAnimationFrame(animate);
//     };

//     animate();

//     return () => {
//       window.removeEventListener("resize", resize);
//     };
//   }, []);

//   return (
//     <canvas
//       id="aurora"
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         width: "100%",
//         height: "100%",
//         zIndex: -1,
//         background: "#0f172a", // deep night background
//       }}
//     ></canvas>
//   );
// };

// export default ComponentC;
import React, { useEffect } from "react";

const ComponentC = () => {
  useEffect(() => {
    const canvas = document.getElementById("click-particles");
    const ctx = canvas.getContext("2d");

    let width, height;
    const resize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
    };
    resize();
    window.addEventListener("resize", resize);

    // 🎨 particle colors
    const colors = ["#ff4d6d", "#4db8ff", "#4dff88", "#ffdb4d", "#b84dff"];

    // 💥 active particles
    const particles = [];

    // Create particles on click
    const handleClick = (e) => {
      for (let i = 0; i < 20; i++) {
        particles.push({
          x: e.clientX,
          y: e.clientY,
          radius: Math.random() * 5 + 3,
          color: colors[Math.floor(Math.random() * colors.length)],
          angle: Math.random() * Math.PI * 2,
          speed: Math.random() * 3 + 1,
          alpha: 1,
        });
      }
    };

    canvas.addEventListener("click", handleClick);

    const animate = () => {
      ctx.clearRect(0, 0, width, height);

      particles.forEach((p, index) => {
        p.x += Math.cos(p.angle) * p.speed;
        p.y += Math.sin(p.angle) * p.speed;
        p.alpha -= 0.02; // fade out

        if (p.alpha <= 0) {
          particles.splice(index, 1); // remove invisible particles
        } else {
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(${hexToRgb(p.color)}, ${p.alpha})`;
          ctx.fill();
        }
      });

      requestAnimationFrame(animate);
    };

    // Convert hex to RGB for rgba()
    const hexToRgb = (hex) => {
      const bigint = parseInt(hex.slice(1), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return `${r}, ${g}, ${b}`;
    };

    animate();

    return () => {
      window.removeEventListener("resize", resize);
      canvas.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <canvas
      id="click-particles"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: -1,
        background: "white", // clean background
        cursor: "pointer",
      }}
    ></canvas>
  );
};

export default ComponentC;
